<template>
  <div class="tenant-create-form" :class="{ 'without-resource-config': !showResourceConfig }">
    <section class="tenant-form-section">
      <b class="section-title">基础属性</b>
      <el-form-item class="geo-action-form-item" label="名称" required>
        <el-input
          v-model="form.name"
          maxlength="50"
          show-word-limit
          placeholder="请输入租户名称"
          @input="$emit('name-input', $event)">
        </el-input>
        <el-button class="geo-action-button" type="text" size="small" icon="el-icon-location-outline" @click="$emit('match-geo')">匹配经纬度</el-button>
      </el-form-item>
      <el-form-item v-if="showExpiry" label="有效期" required>
        <el-date-picker
          v-model="form.expDate"
          type="date"
          value-format="yyyy-MM-dd"
          :clearable="false"
          placeholder="请选择有效期"
          style="width: 100%">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="系统状态" required>
        <div class="display-flex ai-center" style="height: 40px">
          <el-radio-group v-model="form.enabled">
            <el-radio :label="false">禁用</el-radio>
            <el-radio :label="true">启用</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item label="超管账号" required>
        <el-input v-model="form.username" maxlength="50" placeholder="请输入超管账号"></el-input>
      </el-form-item>
      <el-form-item v-if="showReceivers" label="消息接收人">
        <limit-select
          v-model="form.msgReceiverIds"
          :options="receiverOptions"
          placeholder="请选择消息接收人（最多 10 人）"
          @change="$emit('receiver-change', $event)">
        </limit-select>
        <p class="field-hint">此处可选择额外接收消息的人员。</p>
      </el-form-item>
      <div class="display-flex width-percent-100">
        <el-form-item label="经度" style="flex: 1" class="mr-20">
          <el-input v-model="form.longitude" maxlength="20" placeholder="请输入经度"></el-input>
        </el-form-item>
        <el-form-item label="纬度" style="flex: 1">
          <el-input v-model="form.latitude" maxlength="20" placeholder="请输入纬度"></el-input>
        </el-form-item>
      </div>
    </section>
    <section v-if="showResourceConfig" class="tenant-form-section">
      <b class="section-title">运行与资源配置</b>
      <el-form-item label="是否独立部署" class="mb-10" required>
        <div class="display-flex ai-center" style="height: 32px">
          <el-switch v-model="form.independentDeploy" active-color="#E6A23C"></el-switch>
        </div>
      </el-form-item>
      <el-form-item v-if="form.independentDeploy" label="租户服务域名（询问研发）" required>
        <el-input
          v-model="form.serviceDomain"
          maxlength="100"
          show-word-limit
          placeholder="请输入服务域名">
        </el-input>
      </el-form-item>
      <el-form-item label="账户数上限" required>
        <el-input-number
          v-model="form.accountSize"
          :min="0"
          :max="100000"
          controls-position="right"
          style="width: 100%">
        </el-input-number>
      </el-form-item>
      <el-form-item label="短信数上限" required>
        <el-input-number
          v-model="form.smsCount"
          :min="0"
          controls-position="right"
          style="width: 100%">
        </el-input-number>
        <p class="field-hint">数量建议为合同金额数除以10。</p>
      </el-form-item>
      <el-form-item v-if="showAiSettings" label="AI识别数上限" required>
        <el-input-number
          v-model="form.aiCount"
          :min="0"
          controls-position="right"
          style="width: 100%">
        </el-input-number>
        <p class="field-hint">数量建议为合同金额数。</p>
      </el-form-item>
      <el-form-item v-if="showAiSettings" label="更多AI配置">
        <el-select
          v-model="form.openAiList"
          multiple
          filterable
          clearable
          placeholder="请选择AI功能"
          style="width: 100%">
          <el-option label="培训模块-考试范围支持选择课程" value="培训"></el-option>
        </el-select>
      </el-form-item>
    </section>
  </div>
</template>

<script>
import LimitSelect from '@/components/LimitSelect.vue'

export default {
  name: 'TenantCreateForm',
  components: { LimitSelect },
  props: {
    form: { type: Object, required: true },
    receiverOptions: { type: Array, default: () => [] },
    showResourceConfig: { type: Boolean, default: true },
    showExpiry: { type: Boolean, default: true },
    showReceivers: { type: Boolean, default: true },
    showAiSettings: { type: Boolean, default: true }
  }
}
</script>

<style lang="scss" scoped>
.tenant-create-form {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 24px;
}
.tenant-form-section {
  min-width: 0;
}
.without-resource-config .tenant-form-section {
  grid-column: 1 / -1;
}
.section-title {
  display: block;
  font-size: 15px;
  margin: 0 0 12px;
  padding-left: 8px;
  border-left: 3px solid #3377FF;
  line-height: 1.2;
}
.geo-action-form-item {
  position: relative;
}
::v-deep .geo-action-form-item .el-form-item__content {
  position: static !important;
}
.geo-action-button {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}
.field-hint {
  margin: 4px 0 0;
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}
@media (max-width: 720px) {
  .tenant-create-form {
    grid-template-columns: 1fr;
  }
  .without-resource-config .tenant-form-section {
    grid-column: auto;
  }
}
</style>
